import { PartnerChangeType } from "../../types/commonTypes/partnerChangeType";

export const partnerChangeInitialState: PartnerChangeType = {
    change: "Nomination sans départ",
}